import clsx from 'clsx';
import { FC, MouseEvent, useEffect, useRef } from 'react';

export type DropdownItemProps = {
  children: string;
  id: string;
  onClick?: (e: MouseEvent) => void;
  onContextMenu?: (e: MouseEvent) => void;
  className?: string;
  isFocused?: boolean;
  isSelected?: boolean;
};

export const DropdownItem: FC<DropdownItemProps> = ({
  children,
  id,
  onClick,
  onContextMenu,
  className,
  isFocused,
  isSelected,
}) => {
  const ref = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (isFocused) {
      ref.current?.focus();
    }
  }, [isFocused]);

  return (
    <li
      ref={ref}
      id={id}
      className={clsx('dropdown__item', className)}
      role="option"
      aria-selected={isSelected}
      onClick={onClick}
      onContextMenu={onContextMenu}
      tabIndex={0}
    >
      {children}
    </li>
  );
};
